import { createContext, useEffect, useReducer } from "react";

// Helper function to safely parse user data from localStorage
const getUserFromLocalStorage = () => {
  try {
    const user = localStorage.getItem('user');
    return user ? JSON.parse(user) : null;
  } catch (err) {
    console.error("Error parsing user from localStorage:", err);
    return null; // Return null if parsing fails
  }
};

// Initial state
const initial_state = {
  user: getUserFromLocalStorage(),
  loading: false,
  error: null,
};

// Create the AuthContext
export const AuthContext = createContext(initial_state);

// AuthReducer function to handle actions
const AuthReducer = (state, action) => {
  console.log("Dispatching action:", action); // Debugging state changes
  switch (action.type) {
    case 'LOGIN_START':
      return {
        ...state,
        user: null,
        loading: true,
        error: null,
      };
    case 'LOGIN_SUCCESS':
      return {
        ...state,
        user: action.payload,
        loading: false,
        error: null,
      };
    case 'LOGIN_FAILURE':
      return {
        ...state,
        user: null,
        loading: false,
        error: action.payload,
      };
    case 'REGISTER_SUCCESS':
      return {
        ...state,
        user: null,
        loading: false,
        error: null,
      };
    case 'LOGOUT':
      return {
        ...state,
        user: null,
        loading: false,
        error: null,
      };
    default:
      return state;
  }
};

// AuthContextProvider component
export const AuthContextProvider = ({ children }) => {
  const [state, dispatch] = useReducer(AuthReducer, initial_state);

  // Update localStorage whenever the user state changes
  useEffect(() => {
    try {
      if (state.user) {
        localStorage.setItem('user', JSON.stringify(state.user));
      } else {
        localStorage.removeItem('user'); // Clear user data when logged out
      }
    } catch (err) {
      console.error("Error updating localStorage:", err);
    }
  }, [state.user]);

  return (
    <AuthContext.Provider
      value={{
        user: state.user,
        loading: state.loading,
        error: state.error,
        dispatch,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
